module.exports = __webpack_public_path__ + "static/media/02.c3a22502.png";